// ACCORDION: single open at a time, smooth height animation, accessibility
document.addEventListener('DOMContentLoaded', function () {
    const accordions = document.querySelectorAll('.accordion');

    accordions.forEach(accordion => {
        const buttons = accordion.querySelectorAll('.accordion-button');

        buttons.forEach(button => {
            const targetId = button.getAttribute('data-bs-target').substring(1);
            const targetCollapse = document.getElementById(targetId);

            // Start: alle dicht
            targetCollapse.style.maxHeight = '0px';
            targetCollapse.setAttribute('inert', '');
            targetCollapse.setAttribute('aria-hidden', 'true');

            button.addEventListener('click', function () {
                const isOpen = targetCollapse.classList.contains('open');

                // Sluit alle items in dit accordion
                buttons.forEach(btn => {
                    const otherId = btn.getAttribute('data-bs-target').substring(1);
                    const otherCollapse = document.getElementById(otherId);
                    btn.classList.remove('active');
                    btn.setAttribute('aria-expanded', 'false');

                    otherCollapse.classList.remove('open');
                    otherCollapse.style.maxHeight = '0px';
                    otherCollapse.setAttribute('aria-hidden', 'true');
                    otherCollapse.setAttribute('inert', '');
                });

                // Als huidig al open was → gewoon sluiten en return
                if (isOpen) return;

                // Anders: open huidige
                targetCollapse.classList.add('open');
                targetCollapse.style.maxHeight = targetCollapse.scrollHeight + 'px'; // hoogte meten
                targetCollapse.setAttribute('aria-hidden', 'false');
                targetCollapse.removeAttribute('inert');

                this.classList.add('active');
                this.setAttribute('aria-expanded', 'true');
            });
        });
    });
});